import { Component, OnDestroy, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Subject, takeUntil } from 'rxjs';
import { NgIf, NgForOf, NgClass } from '@angular/common';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { NoResultFoundComponent } from '../../../Common/ChildComponents/no-result-found/no-result-found.component';

@Component({
  selector: 'notification-list',
  templateUrl: './notification-list.component.html',
  styleUrls: ['./notification-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NgIf, NgForOf, NgClass, TranslatePipe, MatIconModule, NoResultFoundComponent]
})
export class NotificationListComponent {

  @Input() activity_list: any = [];
  constructor(

    private _router: Router
  ) {

  }

  ngOnInit(): void {

  }

  notificationClick(activity, open_new_tab) {

    var report_notification = [1, 2, 3, 4, 5, 6, 7, 8, 19, 21, 22, 23, 36, 40, 47, 48];

    var time_clock_notification = [15, 16, 38, 39];

    var dispatch_notification = [9, 10, 11, 12, 13, 14];

    let added_date = moment(activity.added_date).format('YYYY-MM-DD H:mm:ss');

    let url = "";

    if (report_notification.includes(activity.notification_type)) {

      if (activity.notification_type == 1 || activity.notification_type == 2) {
        url = '/reports/check-in-out?datetime=' + added_date;
      }
      else if (activity.notification_type == 3 || activity.notification_type == 4 || activity.notification_type == 7) {
        if (activity.incident_report == true) {
          url = '/reports/incident/' + activity.custom_report_id + '?datetime=' + added_date;
        }
        else {
          url = '/reports/standard/' + activity.custom_report_id + '?datetime=' + added_date;
        }
      }
      else if (activity.notification_type == 5) {
        url = '/reports/passdown?datetime=' + added_date;
      }
      else if (activity.notification_type == 6) {
        url = '/reports/task?datetime=' + added_date;
      }
      else if (activity.notification_type == 8) {
        url = '/reports/site-tour?datetime=' + added_date;
      }
      else if (activity.notification_type == 19) {
        url = '/reports/watch-mode?datetime=' + added_date;
      }
      else if (activity.notification_type == 21) {
        url = '/reports/worker-idle-log?datetime=' + added_date;
      }
      else if (activity.notification_type == 22) {
        url = '/reports/geo-fence-log?datetime=' + added_date;
      }
      else if (activity.notification_type == 23) {
        url = '/reports/geo-fence-log?datetime=' + added_date;
      }
      else if (activity.notification_type == 36) {
        url = '/reports/panic-button-log?datetime=' + added_date;
      }
      else if (activity.notification_type == 40) {
        url = '/reports/checklist?datetime=' + added_date;
      }
      else if (activity.notification_type == 47) {
        url = '/reports/vehicle-patrol?datetime=' + added_date;
      }
    }
    else if (time_clock_notification.includes(activity.notification_type)) {

      url = '/time-log?datetime=' + added_date;
    }
    else if (dispatch_notification.includes(activity.notification_type)) {
      url = '/dispatch-tickets/' + activity.dispatch_id + '/detail';
    }
    else if (activity.notification_type == 17) {

      url = '/shift-status?shift_id=' + activity.shift_id;
    }
    else if (activity.notification_type == 18) {

      url = '/open-shifts?shift_id=' + activity.shift_id;
    }
    else if (activity.notification_type == 20) {
      url = '/job-sites/' + activity.location_id + '/job-order';
    }
    else if (activity.notification_type == 24) {
      url = '/company/policy';
    }
    else if (activity.notification_type == 25) {
      url = '/clients';
    }
    else if (activity.notification_type == 26) {
      url = '/job-sites';
    }
    else if (activity.notification_type == 27) {
      url = '/field-workers';
    }
    else if (activity.notification_type == 28) {
      url = '/dispatch-tickets';
    }
    else if (activity.notification_type == 34) {
      url = '/time-off?datetime=' + added_date;
    }
    else if (activity.notification_type == 35) {
      url = '/shift-exchange?datetime=' + added_date;
    }
    else if (activity.notification_type == 37) {
      url = '/schedule';
    }
    else if (activity.notification_type == 45) {
      url = '/field-workers/' + activity.guard_id + '/availability';
    }
    else if (activity.notification_type == 46) {
      let pay_period_start = moment(activity.pay_period_start).format('YYYY-MM-DD');
      let pay_period_end = moment(activity.pay_period_end).format('YYYY-MM-DD');
      url = '/past-payroll/details?guard_id=' + activity.guard_id + '&pay_period_start=' + pay_period_start + '&pay_period_end=' + pay_period_end;
    }
    else if (activity.notification_type == 49) {

      if (activity.time_log_id > 0) {
        url = '/time-log?time_log_id=' + activity.time_log_id;
      }
      else if (activity.report_id > 0) {
        if (activity.incident_id > 0) {
          url = '/reports/incident/' + activity.custom_report_id + '?report_id=' + activity.report_id;
        }
        else {
          url = '/reports/standard/' + activity.custom_report_id + '?report_id=' + activity.report_id;
        }
      }
      else if (activity.task_id > 0) {
        url = '/reports/task?task_id=' + activity.task_id;
      }

    }
    if (url != "") {
      if (open_new_tab == "no") {
        this._router.navigateByUrl(url);
      }
      else {
        window.open(url, '_blank');
      }

     
      //._toolbarService.onActivityCountChanged.next(this._toolbarService.unread_notification_count);
    }
  }
  getWorkerInitials(name: string | null | undefined): string {
    if (!name?.trim()) {
      return '';
    }

    const nameParts = name.trim().split(/\s+/);

    const firstInitial = nameParts[0]?.charAt(0) || '';
    const lastInitial = nameParts.length > 1
      ? nameParts[nameParts.length - 1]?.charAt(0) || ''
      : '';

    return (firstInitial + lastInitial).toUpperCase();
  }
}

